import { SOURCE } from "@/constants";
import { msg } from "@lingui/core/macro";

const SOURCE_TYPE_PODCAST_ACTION = msg`Lyssna på hela avsnittet`;
const SOURCE_TYPE_RADIO_ACTION = msg`Lyssna på hela inslaget`;
const SOURCE_TYPE_TV_ACTION = msg`Se hela inslaget`;
const SOURCE_TYPE_YOUTUBE_ACTION = msg`Se hela videon`;
const SOURCE_TYPE_WEB_TV_ACTION = msg`Se hela inslaget`;
const SOURCE_TYPE_MANUAL_ACTION = msg`Läs hela artikeln`;
const SOURCE_TYPE_FACEBOOK_ACTION = msg`Visa hela inlägget`;
const SOURCE_TYPE_INSTAGRAM_ACTION = msg`Visa hela inlägget`;
const SOURCE_TYPE_TIKTOK_ACTION = msg`Se hela videon`;
const SOURCE_TYPE_TWITTER_ACTION = msg`Visa hela inlägget`;
const SOURCE_TYPE_LINKEDIN_ACTION = msg`Visa hela inlägget`;
const SOURCE_TYPE_NEWS_ACTION = msg`Läs hela artikeln`;

export const SOURCE_ACTION = {
  [SOURCE.PODCAST]: SOURCE_TYPE_PODCAST_ACTION,
  [SOURCE.RADIO]: SOURCE_TYPE_RADIO_ACTION,
  [SOURCE.TV]: SOURCE_TYPE_TV_ACTION,
  [SOURCE.YOUTUBE]: SOURCE_TYPE_YOUTUBE_ACTION,
  [SOURCE.YOUTUBE_SHORTS]: SOURCE_TYPE_YOUTUBE_ACTION,
  [SOURCE.WEB_TV]: SOURCE_TYPE_WEB_TV_ACTION,
  [SOURCE.FACEBOOK]: SOURCE_TYPE_FACEBOOK_ACTION,
  [SOURCE.INSTAGRAM]: SOURCE_TYPE_INSTAGRAM_ACTION,
  [SOURCE.TIKTOK]: SOURCE_TYPE_TIKTOK_ACTION,
  [SOURCE.TWITTER]: SOURCE_TYPE_TWITTER_ACTION,
  [SOURCE.LINKEDIN]: SOURCE_TYPE_LINKEDIN_ACTION,
  [SOURCE.NEWS]: SOURCE_TYPE_NEWS_ACTION,
  [SOURCE.MANUAL]: SOURCE_TYPE_MANUAL_ACTION,
};
